import { existsSync } from 'node:fs';
import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';

function repoNodeModulesDir(fromDir: string): string {
  return join(fromDir, '..', '..', '..', 'node_modules');
}

function firstDirWithWebTreeSitterWasm(candidates: string[]): string | null {
  for (const dir of candidates) {
    if (existsSync(join(dir, 'web-tree-sitter.wasm'))) return dir;
  }
  return null;
}

/** Directory containing copied `web-tree-sitter.wasm` and language `.wasm` / `tags.scm` assets. */
export function getTreeSitterAssetsDir(): string {
  const moduleDir = dirname(fileURLToPath(import.meta.url));
  const fromModule = firstDirWithWebTreeSitterWasm([
    join(moduleDir, 'tree-sitter'),
    join(moduleDir, '..', 'tree-sitter'),
    join(moduleDir, '..', '..', 'dist', 'tree-sitter'),
  ]);
  if (fromModule) return fromModule;

  const fromNodeModules = firstDirWithWebTreeSitterWasm([join(repoNodeModulesDir(moduleDir), 'web-tree-sitter')]);
  if (fromNodeModules) return fromNodeModules;

  throw new Error(
    'Missing web-tree-sitter.wasm. Run `pnpm build` in packages/cli to copy tree-sitter assets into dist/tree-sitter.',
  );
}
